import {includes} from 'lodash/fp';

const matingTabKeys = ['cowSelection', 'bullSelection', 'paramsSelection', 'result'] as const;

/** Allowed mating tab identifiers. */
export type MatingTabKey = typeof matingTabKeys[number];

/**
 * Checks whether a string is a valid mating tab key.
 *
 * @param x Candidate tab key.
 * @returns `true` when the value matches a known mating tab.
 */
export const matingTabGuard = (x: string): x is MatingTabKey => includes(x, matingTabKeys);
